import { RelatorioContaReceberModel } from "@/models/contabil/contas-receber/RelatorioContaReceberModel"
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';

export default class ContabilContaReceberService { 

    static gerarRelatorio(relatorio : RelatorioContaReceberModel): Promise<any> {

        const requestRelatorioContaReceberDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
            tipoCartao: relatorio.tipoCartao?.codigo ? `${relatorio.tipoCartao.codigo}`: undefined
        }

        return integracaoContabilApi.gerarRelatorioContasReceber(requestRelatorioContaReceberDTO);
    }

    static gerarRelatorioExcel(relatorio : RelatorioContaReceberModel): Promise<any> {

        const requestRelatorioContaReceberDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
            tipoCartao: relatorio.tipoCartao?.codigo ? `${relatorio.tipoCartao.codigo}`: undefined
        }

        return integracaoContabilApi.gerarRelatorioContasReceberExcel(requestRelatorioContaReceberDTO);
    }

    static filtrar(filtro: RelatorioContaReceberModel): Promise<any> {
        const filtroDTO = {
          inicio: filtro.inicio,
          fim: filtro.fim,
          tipoNaturezaServico: filtro.naturezaServico?.valor,
          tipoCartao: filtro.tipoCartao?.codigo ? `${filtro.tipoCartao.codigo}`: undefined
        };
    
        return integracaoContabilApi.filtrarContaReceber(filtroDTO);
      }

      static realizarBaixa(idContaReceber: number, dataBaixa: string): Promise<any> {
        return integracaoContabilApi.realizarBaixa(idContaReceber, dataBaixa);
      }
}

